module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account"
  }, [_c('div', {
    staticClass: "pic-imgBox"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/bg.jpg"),
      "id": "topBg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/header.png")
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "msg-list"
  }, [_c('li', [_c('span', {
    staticClass: "tag-label"
  }, [_vm._v("昵称：")]), _c('span', {
    staticClass: "tag-txt"
  }, [_vm._v("似水流年")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "tag-label"
  }, [_vm._v("QQ：")]), _c('span', {
    staticClass: "tag-txt"
  }, [_vm._v("705597001")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "tag-label"
  }, [_vm._v("邮箱：")]), _c('span', {
    staticClass: "tag-txt"
  }, [_vm._v("705597001@qq.com")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "tag-label"
  }, [_vm._v("GitHub：")]), _c('a', {
    staticClass: "tag-txt",
    attrs: {
      "href": "https://github.com/yunchen132",
      "target": "_blank"
    }
  }, [_vm._v("https://github.com/yunchen132")])])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("如果本项目对你有，欢迎支付宝打赏")]), _vm._v(" "), _c('div', {
    staticClass: "support-box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/support.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-ea7030c2!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/Account.vue
// module id = 33
// module chunks = 0